<template>
  <div class="header">
    <div class="header-top">
      <div class="header-left">
        <img v-if="!isEnglish" src="@/assets/image/home/headTitle.png" alt="">
        <span v-else style="width: 1020px;height: 65px;display: flex;align-items: center">
          <img src="@/assets/image/home/logo-65.png" alt="" style="width: 65px">
          <span style="font-size: 24px;font-weight: 600;margin-left: 10px">Ocean Remote Sensing Big Data Information Service and Decision Center</span>
        </span>
      </div>
      <div class="header-right">
        <p style="margin-right:12px;">{{ nowDate }}</p>
        <el-badge :max="99" :value="shopTotal_getter" class="item">
          <div class="header-tool center" @click="menuClick('shopcar')">
            <svg t="1637889535031" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="1883" width="16" height="16">
              <path
                  d="M346.112 806.912q19.456 0 36.864 7.168t30.208 19.968 20.48 30.208 7.68 36.864-7.68 36.864-20.48 30.208-30.208 20.48-36.864 7.68q-20.48 0-37.888-7.68t-30.208-20.48-20.48-30.208-7.68-36.864 7.68-36.864 20.48-30.208 30.208-19.968 37.888-7.168zM772.096 808.96q19.456 0 37.376 7.168t30.72 19.968 20.48 30.208 7.68 36.864-7.68 36.864-20.48 30.208-30.72 20.48-37.376 7.68-36.864-7.68-30.208-20.48-20.48-30.208-7.68-36.864 7.68-36.864 20.48-30.208 30.208-19.968 36.864-7.168zM944.128 227.328q28.672 0 44.544 7.68t22.528 18.944 6.144 24.064-3.584 22.016-13.312 37.888-22.016 62.976-23.552 68.096-18.944 53.248q-13.312 40.96-33.28 56.832t-49.664 15.872l-35.84 0-65.536 0-86.016 0-96.256 0-253.952 0 14.336 92.16 517.12 0q49.152 0 49.152 41.984 0 20.48-9.728 35.328t-38.4 14.848l-49.152 0-94.208 0-118.784 0-119.808 0-99.328 0-55.296 0q-20.48 0-34.304-9.216t-23.04-24.064-14.848-32.256-8.704-32.768q-1.024-6.144-5.632-29.696t-11.264-58.88-14.848-78.848-16.384-87.552q-19.456-103.424-44.032-230.4l-76.8 0q-15.36 0-25.6-7.68t-16.896-18.432-9.216-23.04-2.56-22.528q0-20.48 13.824-33.792t37.376-13.312l21.504 0 21.504 0 25.6 0 34.816 0q20.48 0 32.768 6.144t19.456 15.36 10.24 19.456 5.12 17.408q2.048 8.192 4.096 23.04t4.096 30.208q3.072 18.432 6.144 38.912l700.416 0zM867.328 194.56l-374.784 0 135.168-135.168q23.552-23.552 51.712-24.064t51.712 23.04z"
                  p-id="1884" fill="#1296db"></path>
            </svg>
          </div>
        </el-badge>
        <el-badge :max="99" :value="messageTotal_getter" class="item">
          <div class="header-tool center" style="margin-left:28px;" @click="goUserCenter">
            <svg t="1637889588581" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="3629" width="16" height="16">
              <path
                  d="M512 960c49.6 0 88-38.4 88-88H424c0 49.6 38.4 88 88 88z m288.8-286.4V444.8c0-137.6-97.6-252.8-224.8-283.2v-28.8c0-32-17.6-60.8-48-67.2-44-10.4-80 23.2-80 66.4v30.4C320.8 192 223.2 307.2 223.2 444.8v228.8L136 763.2v44.8h752v-44.8l-87.2-89.6z"
                  p-id="3630" fill="#1296db"></path>
            </svg>
          </div>
        </el-badge>
        <div class="languageBtn">
          <span v-if="!isEnglish" @click="changeLanguage(true)">EN</span>
          <span v-else @click="changeLanguage(false)">中文</span>
        </div>
        <div class="tool-line"></div>
        <el-dropdown trigger="click" @command="handleCommand" v-if="token_getter">
            <span class="el-dropdown-link center">
              <svg t="1638356413039" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="6307" width="32" height="32"><path
                  d="M626.568192 981.999616l-23.379968 0-36.857856 0.283648L68.137984 982.283264l0-23.989248c0 0-10.815488-134.006784 186.535936-168.308736 0 0 150.230016-20.28032 160.748544-61.595648 0 0 5.732352-4.596736 1.502208-52.578304-9.017344-102.161408-75.86816-150.234112-102.909952-189.293568-27.041792-39.063552-29.293568-84.13184-29.293568-84.13184 0-11.264 4.716544-15.391744 12.560384-22.626304 9.696256-8.950784 6.786048-18.4576 4.934656-28.52864-7.04512-38.23616-7.666688-99.662848-0.970752-138.138624 1.502208-45.820928 43.56608-82.625536 43.56608-82.625536 7.892992-6.695936 15.803392-14.062592 21.343232-22.898688 1.547264-2.460672 2.970624-5.09952 3.8144-7.897088 3.16928-10.548224-7.560192-18.292736-5.407744-29.51168 1.942528-10.116096 19.280896-10.61376 29.766656-11.164672 23.614464-1.243136 47.347712-2.172928 70.925312-0.366592C641.71008 72.155136 699.725824 137.1136 699.725824 137.1136c13.73696 16.449536 22.787072 36.566016 28.23168 57.184256 1.630208 6.16448 3.028992 12.45696 3.785728 18.79552 5.501952 31.602688 5.481472 64.559104 3.770368 96.494592-0.815104 15.22688-2.584576 30.215168-4.819968 45.282304-1.17248 7.8848-0.571392 15.222784 4.70016 21.523456 4.4032 5.271552 9.44128 8.95488 11.60192 15.881216 1.011712 3.238912 1.275904 6.736896 1.275904 10.112 0 0-2.255872 45.068288-29.297664 84.13184-27.041792 39.059456-93.893632 87.13216-102.905856 189.293568-4.23424 47.981568 1.502208 52.578304 1.502208 52.578304 10.514432 41.314304 160.748544 61.595648 160.748544 61.595648 199.55712 37.010432 186.53184 168.308736 186.53184 168.308736l0 23.989248-131.3792 0 20.70016-0.283648L836.49536 982.00064l-36.64384 0L626.568192 982.00064 626.568192 981.999616z"
                  p-id="6308" fill="#0269FF"></path></svg>
              <div style="color:white;margin-left:8px;cursor: pointer">
                <p>{{ $t('header.Welcome') }}！</p>
                <p>{{ userInfo_getter ? userInfo_getter.loginname : '空' }}</p>
              </div>
              <i class="el-icon-arrow-down el-icon--right" style="color:white"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command='e'>
              视频教程
            </el-dropdown-item> -->
            <el-dropdown-item command='d' v-if="authNBYH()">
              <a class="help" href="http://120.196.115.131:8101/用户手册.pdf" target="_blank">
                {{
                  $t('header.help')
                }}</a>
            </el-dropdown-item>
            <el-dropdown-item command='a'>{{ $t('header.PersonalCenter') }}</el-dropdown-item>
            <el-dropdown-item command='b'>{{ $t('header.orderForm') }}</el-dropdown-item>
            <el-dropdown-item command='c'>{{ $t('header.Logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button size="medium" v-else type="primary" icon="el-icon-user-solid" @click="login" style="padding:10px;">
          {{ $t('header.Login') }}/{{ $t('header.Register') }}
        </el-button>
        <!-- <el-button size="medium" v-if="!token_getter" type="primary" @click="regist">注册</el-button> -->
      </div>
    </div>
    <div class="menuList">
      <div class="menu-bg-mask">
        <div class="hr-line"></div>
        <div class="menu-site center" :class="item.type===$route.meta.menu?'menu-site-ac':'menu-site'"
             v-for="(item,index) in menuList" :key="index" @click="menuClick(item.name)" v-show="isRanNBYH(item)">
          <div :class="isEnglish?'menu-name-en':'menu-name'">
            {{ $t(`header.${item.title}`) }}
          </div>
          <div class="menu-children" v-if="item.children&&!item.acType">
            <div v-for="site in item.children" :key="site.index">
              <div class="other-site center" :class="isEnglish?'other-site-en':''" v-if="isShow(site)"
                   @click.stop="menuClick2(site)">
                <div v-if="index < 5 || index ===6">{{ site.title }}</div>
                <span v-else>{{ $t(`header.${site.title}`) }}</span>
              </div>
            </div>
          </div>
          <div class="menu-children-spa" v-if="item.children&&item.acType">
            <div class="nei-box">
              <div class="other-site center" :class="isEnglish?'other-site-en':''" v-for="site in item.children"
                   :key="site.index"
                   @click.stop="menuClick2(site)">{{ site.title }}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import {proxyLogout} from "@/utils/config"
import axios from 'axios'
import {
  getSatelliteClass
} from "@/api/satellite/index"
import {
  getLikeByDicCodelist
} from "@/api/product"
import {
  getAlgorithmType
} from "@/api/algorithm/index"
import {
  getShopCarList
} from "@/api/product/index"

export default {
  data() {
    return {
      timercc: null,
      value: 'theme1',
      nowDate: "",
      getTimer: null,
      menuList: [
        {title: "Home", name: 'Home', type: 'Home'},
        {title: 'SatelliteData', name: 'satelliteData', acType: 'spa', type: 'Satellite', children: []},
        {title: 'ProductData', name: 'product', type: 'Product', children: []},
        {title: 'AlgorithmPlatform', name: 'Algorithm', type: "Algorithm", children: []},
        {title: 'Maps', name: 'map-show', type: 'map-show', isAdmin: true},
        {
          title: "ServicesResource", type: '', children: [
            {title: 'RemoteSensingCloudComputingService', name: "RemoteSensingCloudComputingService"},
            {title: 'DataResource', name: "DataResource", isAdmin: true, isRanNBYH: true},
            {title: 'OrbitPrediction', name: 'OrbitPrediction'},
            {title: 'DataService', name: "devcenter"},
            // {title: 'DevelopmentSDK', url: 'https://iclient.supermap.io/', name: 'DevelopmentSDK'},
            // {title: 'CloudComputingServices', name: 'CloudComputingServices'},
            {title: 'DataDistributionAndTransfer', name: 'DataDistributionConvergence', isAdmin: true},
            {title: 'RPAManagement', name: "RpaManager", isAdmin: true},
            {title: 'AlgorithmScheduling', name: 'AlgorithmScheduling', isAdmin: true},
            {title: 'OperationManagement', name: "Operat", isAdmin: true},
          ]
        },
        {
          title: "DataDecisionMaking", type: '', children: [], isAdmin: true
        },
        {
          title: "DataSubmission", type: '', children: [
            {title: 'ApplicationForSatelliteData', name: "satelliteDataApply"},
            {title: 'ProductUpload', name: "productUpload"},
            {title: 'AlgorithmManagement', name: 'AlgorithmManager'},
            // {title: 'AlgorithmsLibrary', name: 'AlgorithmsLibrary'},
          ]
        },
        {
          title: "About", type: '', children: [
            {title: 'IntroductionOfPlatform', name: 'introduction'},
            {title: 'LaboratoryIntroduction', name: "article"},
            {title: 'OrganizationalStructure', name: "organize"},
            {title: 'DevelopmentHistory', name: 'course'},
            // {title: 'ContactUS', name: 'contact'},
          ]
        },
      ],
      isEnglish: false
    }
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  watch: {
    zhuti_values(val) {
      let iframeC = document.getElementsByTagName('iframe')
      if (!val) {
        window.document.documentElement.setAttribute('data-theme', 'theme2')
      } else {
        window.document.documentElement.setAttribute('data-theme', 'theme1')
      }
      for (let i = 0; i < iframeC.length; i++) {
        let siteFrame = iframeC[i]
        if (val) {
          siteFrame.contentWindow.postMessage({theme: 'theme1'}, "*");
        } else {
          siteFrame.contentWindow.postMessage({theme: 'theme2'}, "*");
        }
      }
    },
  },
  methods: {
    ...mapMutations(['SET_theme']),
    viewVideo() {
      window.open('http://120.196.115.131:8101/productImages/jupyterDemo.mp4', '_blank', "width=1300,height=830,top=50,left=1500")
    },
    /**
     * @description: 仅用于判断内部用户及以上权限查看使用帮助
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-08 18:23:54
     * @return {*}
     */
    authNBYH(){
      let info = sessionStorage.getItem('userInfo')
      if (JSON.parse(info).depid === '5aa0a4e4dbb24ddd821c2167b255bdb2' || JSON.parse(info).depid === '02' || JSON.parse(info).depid === '593c3ca5f8a442c485b558f1b5fef328') {
        return true
      } else {
        return false
      }
    },
    isRanNBYH(item) {
      let info = sessionStorage.getItem('userInfo')
      if (item.isAdmin) {
        if (!info) {
          return false
        } else {
          if (JSON.parse(info).depid === '5aa0a4e4dbb24ddd821c2167b255bdb2' || JSON.parse(info).depid === '02' || JSON.parse(info).depid === '593c3ca5f8a442c485b558f1b5fef328') {
            return true
          } else {
            return false
          }
        }
      } else {
        return true
      }
    },
    isShow(item) {
      let info = sessionStorage.getItem('userInfo')
      if (item.isRanNBYH) {
        if (item.isAdmin) {
          if (!info) {
            return false
          } else {
            if (JSON.parse(info).depid === '5aa0a4e4dbb24ddd821c2167b255bdb2' || JSON.parse(info).depid === '02' || JSON.parse(info).depid === '593c3ca5f8a442c485b558f1b5fef328') {
              return true
            } else {
              return false
            }
          }
        } else {
          return true
        }
      }
      if (item.isAdmin) {
        if (!info) {
          return false
        } else {
          if (JSON.parse(info).depid === '593c3ca5f8a442c485b558f1b5fef328' || JSON.parse(info).depid === '02') {
            return true
          } else {
            return false
          }
        }
      } else {
        return true
      }
    },
    async getJUECE() {
      let res = await getLikeByDicCodelist({code: ['INTELLIGENT_DECISION_TYPE']})
      if (res.code === '000000') {
        let juece = res.data.INTELLIGENT_DECISION_TYPE
        juece.forEach(element => {
          element.title = element.dicItemName
          element.name = 'seaIce'
        });
        this.menuList[6].children = juece
      }
    },
    async getAlgorithmMenuList() {
      let {data} = await getAlgorithmType()
      let res = data
      res.forEach((element, index) => {
        this.menuList[3].children.push(
            {title: element.dicItemName, name: 'Algorithm', type: 'router', index: index},
        )
      });
    },
    async getSatelliteMenuList() {
      let {data} = await getSatelliteClass()
      let res = data
      res.forEach((element) => {
        this.menuList[1].children.push(
            {title: element.typeName, name: 'satelliteData', type: 'routerpkid', index: element.pkid},
        )
      });
    },
    async getProductMenuList() {
      let {data} = await getShopCarList()
      let res = data
      res.forEach((element, index) => {
        this.menuList[2].children.push(
            {title: element.dicItemName, name: 'product', type: 'router', index: index},
        )
      });
    },
    changeSwitch(val) {
      if (!val) {
        this.SET_theme('theme2')
      } else {
        this.SET_theme('theme1')
      }
    },
    changeLanguage(val) {
      if (!val) {
        this.$i18n.locale = 'zh';
        this.isEnglish = false
        window.localStorage.setItem('language', 'zh')
      } else {
        this.$i18n.locale = 'en';
        this.isEnglish = true
        window.localStorage.setItem('language', 'en')
      }
      this.$router.go(0)
    },
    login() {
      axios.get('config/AllUrl.json').then(res => {
        if (res) {
          let sevice = "http://" + window.location.host + '/';
          window.location.href = res.loginHeader + '?service=' + encodeURIComponent(sevice)
        }
      })
    },
    handleCommand(val) {
      switch (val) {
        case 'b':
          this.$router.push({name: 'Order'})
          break;
        case 'e':
          this.$router.push({name: 'VideoTutorial'})
          break;
        case 'a':
          this.$router.push({name: 'webmain'})
          break;
        case 'c':
          this.logout()
          break;
        default:
          break;
      }
    },
    goUserCenter() {
      this.$router.push({
        name: 'webmain',
        query: {
          type: 'msg'
        }
      })
    },
    async logout() {
      let resp = await this.$store.dispatch('LogOut')
      if (resp.code == '0') {
        let sevice = "http://" + window.location.host + '/';
        window.location.href = proxyLogout + "cas/logout" + '?service=' + encodeURIComponent(sevice)
      }
    },
    menuClick(routeName) {
      this.$router.push({name: routeName})
    },
    menuClick2(routeName) {
      if (routeName.name === 'seaIce') {
        this.$router.push({
          name: routeName.name,
          query: {
            typeId: routeName.pkid
          }
        })
        return
      }

      if (routeName.type === 'routerpkid') {
        this.$router.push({
          name: routeName.name,
          query: {
            typeId: routeName.index
          }
        })
        return
      }
      if (routeName.type === 'router') {
        this.$router.push({
          name: routeName.name,
          query: {
            typeId: routeName.index
          }
        })
        return
      }
      if (routeName.name == 'RemoteSensingCloudComputingService') {
        //权限2
        this.$router.push('/cloudComputing')
        return
      }
      if (routeName.name == 'AlgorithmScheduling' || routeName.name == 'devcenter' || routeName.name == 'CloudComputingServices' || routeName.name == 'productUpload' || routeName.name == 'satelliteDataApply' || routeName.name == 'AlgorithmsLibrary' || routeName.name == 'AlgorithmManager') {
        if (this.promisShow(2)) {
          return
        }
      }
      if (routeName.name == 'sgsmanager') {
        if (this.promisShow(3)) {
          return
        }
      }
      if (routeName.url) {
        window.open(routeName.url)
        return
      }
      this.$router.push({name: routeName.name})
    },
    regist() {
      this.$router.push('regist')
    },
    /**
     * @description: 获取当前时间 年月日时分秒
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-07 14:39:38
     * @return {*}
     */
    getNowDate() {
      this.nowDate = new Date(+new Date() + 8 * 3600 * 1000).toJSON().substr(0, 19).replace("T", " ")
    }
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(['messageTotal_getter', 'userInfo_getter', 'zhuti_values', 'token_getter', 'shopTotal_getter']),
    userPwd() {
      if (this.isEnglish) {
        return 'username：' + this.applyResult.serverUser + 'password：' + this.applyResult.serverPass
      } else {
        return '用户名：' + this.applyResult.serverUser + '密码：' + this.applyResult.serverPass
      }
    }
  },
  created() {
    this.getTimer = setInterval(this.getNowDate, 1000)
    this.getProductMenuList()
    this.getSatelliteMenuList()
    this.getAlgorithmMenuList()
    this.getJUECE()
  },
  beforeDestroy() {
    if (this.getTimer) {
      clearInterval(this.getTimer);
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .input-place.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: black;
  cursor: not-allowed;
}
/deep/ .el-dropdown-menu__item{
  .help {
    font-size: 14px;
    color: #606266;
    text-decoration: none;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}

/deep/ .input-place {

  input::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }

  input::-moz-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }

  input::-ms-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }

  textarea::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }

  textarea::-moz-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }

  textarea::-ms-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }
}

.logout {
  position: absolute;
  left: 0;
  top: 0;
  width: 100px;
  height: 100px;
}

.header {
  height: 206px;

  &-top {
    height: 160px;
    background-image: url("../assets/image/home/pexels-ben-mack-5326990.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 36px;
    color: white;

    .header-left {
      display: flex;
      align-items: center;

      img {
        width: 637px;
        height: 65px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 15px;

      .help {
        font-size: 14px;
        position: absolute;
        top: 30px;
        right: 57px;
        cursor: pointer;
        border-bottom: 1px solid #ffffff;
        color: #ffffff;
        text-decoration: none;
      }

      .tool-line {
        height: 34px;
        width: 1px;
        background-color: rgba(245, 245, 245, 1);
        margin: 0 12px;
      }

      .header-tool {
        width: 36px;
        height: 36px;
        background-color: rgba(245, 245, 245, 1);
        border-radius: 5px;
        margin-left: 12px;
        cursor: pointer;
        position: relative;

        .dia-mask-system {
          display: none;
          position: absolute;
          right: 0;
          top: 36px;
          width: 154px;
          height: 100px;
          border-radius: 4px;
          z-index: 500;

          .dia-nei {
            margin-top: 10px;
            width: 154px;
            // height: 70px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 4px;
            color: #3390F8;
            padding: 10px 0;

            .zhuti {
              span {
              }
            }
          }
        }
      }

      .languageBtn {
        justify-content: center;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        background-color: #409eff;
        border-radius: 4px;
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;

        > span {
          display: inline-block;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .header-tool:hover {
        .dia-mask-system {
          display: block;
        }
      }
    }
  }

  .menuList {
    height: 46px;
    background-image: url("../assets/image/home/pexels-ben-mack-5326990(1).png");
    background-size: 100% 100%;

    .menu-bg-mask {
      // background-color: rgba(255,255,255,0.2);
      display: flex;
      justify-content: center;
      // padding: 0 180px;
      position: relative;

      .hr-line {
        background-color: rgba(255, 255, 255, 0.2);
        width: 100%;
        height: 1px;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
      }

      .menu-site {
        width: 194px;
        height: 42px;
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        background-color: rgba(255, 255, 255, 0.33);
        position: relative;
        cursor: pointer;
        border-radius: 5px;

        .menu-name {
          text-align: center;
          color: white;
          font-size: 18px;
          font-weight: 600;
        }

        .menu-name-en {
          text-align: center;
          color: white;
          font-size: $font_medium;
          font-weight: 600;
        }

        .menu-children {
          display: none;
          position: absolute;
          white-space: nowrap;
          top: 0;
          left: 50%;
          transform: translate(-50%, 46px);
          @include header_menu_bg();
          z-index: 10;
          width: auto;
          padding: 0 5px;
          min-width: 180px;

          .other-site {
            height: 48px;
            border-bottom: 1px solid rgba(146, 154, 178, 1);
            line-height: 47px;
            font-size: 16px;
          }

          .other-site-en {
            font-size: $font_medium_s;
          }

          .other-site:hover {
            // background: rgba(146,154,178,0.2);
            @include header_menu_hover_bg();
          }
        }

        .menu-children-spa {
          display: none;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 46px);
          @include header_menu_bg();
          z-index: 10;
          width: 320px;

          .nei-box {
            display: flex;
            flex-wrap: wrap;
          }

          .other-site {
            height: 36px;
            line-height: 36px;
            width: 50%;
            color: white;
            font-size: 16px;
          }

          .other-site-en {
            font-size: $font_medium_s;
          }

          .other-site:hover {
            color: rgb(38, 125, 255);
          }
        }
      }

      .menu-site:hover {
        border-bottom: 4px solid rgba(38, 125, 255, 1);

        .menu-children {
          display: block;
        }

        .menu-children-spa {

          display: block;
        }
      }

      .menu-site-ac {
        // background-color: rgba(177, 43, 43, 0.33);
        background-color: rgba(255, 255, 255, 0.6);

        .menu-name {
          text-align: center;
          color: #0269FF;
          font-size: 18px;
          font-weight: 600;
        }

        .menu-name-en {
          text-align: center;
          color: #0269FF;
          font-size: $font_medium;
          font-weight: 600;
        }
      }
    }
  }
}

/deep/ .cloud-computing .el-dialog {
  background-image: url("../assets/image/header/bg.png");

  .el-dialog__title {
    color: #3993F9;
  }
}

.row-app {
  display: flex;
  align-items: center;

  .title {
    width: 100px;
    text-align: left;
    color: #3993F9;
  }

  .n1 {
    flex: 1;
  }
}
</style>
